<!--学生端-公告通知-->
<template>
  <div class="studentMessageCenter">
    <!--左边-->
    <div class="studentMessageCenter-left">
      <Title text="通知公告" class="studentMessageCenter-title"></Title>

      <ul
        v-if="noticeDatas.length > 0"
        class="notice-lists"
        infinite-scroll-immediate
        infinite-scroll-delay="500"
        infinite-scroll-distance="10"
        v-infinite-scroll="load"
      >
        <li
          v-for="item in noticeDatas"
          :key="item.id"
          class="item"
          @click="getContent(item)"
          :class="currentData.id == item.id ? 'active' : ''"
        >
          <span class="con">{{ item.title }} </span>
          <span class="date">{{ item.created_at.substring(0, 10) }}</span>
        </li>
      </ul>

      <ComponentEmpty v-else title="暂无数据" tips="" />
    </div>
    <!--右边部分-->
    <div class="studentMessageCenter-right">
      <p class="title">
        <span class="tit">{{ currentData.title }} </span>
        <span
          class="date"
          style="align-self: flex-end"
          v-html="currentData.created_at"
        ></span>
      </p>
      <div class="content" v-html="currentData.content"></div>
      <ComponentEmpty v-if="!currentData.content" title="暂无数据" tips="" />
    </div>
  </div>
</template>

<script>
import { getNotice } from "@/api/basic";
export default {
  name: "index",
  data() {
    return {
      noticeDatas: [],
      currentData: {},
      start: 10,
      perPage: 1,
    };
  },
  created() {
    this.init();
  },
  methods: {
    /**
     * 初始化第一条内容
     */
    init() {
      this.getDetail().then((res) => {
        if (res) {
          const uuid = this.$route.query.uuid;
          if (uuid) {
            res.list.forEach((item) => {
              if (item.id == uuid) {
                this.currentData = item;
              }
            });
          } else if (res.list[0]) {
            this.currentData = res.list[0];
          }
        }
      });
    },
    /**
     * 获取公告
     */
    async getDetail() {
      const params = {
        page: this.perPage,
        limit: this.start,
      };
      const { result } = await getNotice(params);
      if (result) {
        this.noticeDatas = this.noticeDatas.concat(result.list);
        return result;
      }
    },
    /**
     * 加载新数据
     */
    load() {
      this.getDetail();
    },
    /**
     * 获取当前点击公告内容
     */
    getContent(item) {
      this.currentData = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.studentMessageCenter {
  padding: 20px;
  padding-bottom: 0;
  display: flex;
  height: $menuH;

  /*左边*/
  .studentMessageCenter-left {
    flex: 3;
    background-color: #ffffff;
    padding: 0 20px;
    height: 100%;
    border-radius: 5px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .notice-lists {
      flex: 1;
      overflow-y: auto;
      position: relative;

      &::-webkit-scrollbar {
        display: none;
      }

      .item {
        display: flex;
        padding: 5px 0;
        cursor: pointer;
        align-items: center;
        height: 60px;
        border-bottom: 1px solid $gray;

        &.active,
        &:hover {
          @include fontColor("primary");
        }

        .con {
          flex: 1;
          margin-right: 10px;
          @extend %ellipse;
        }
      }
    }
  }

  /*右边*/
  .studentMessageCenter-right {
    flex: 7;
    margin-left: 15px;
    background-color: #ffffff;
    border-radius: 5px;
    padding: 20px;
    overflow-y: auto;
    position: relative;

    &::-webkit-scrollbar {
      display: none;
    }

    .title {
      margin-top: 62px;
      display: flex;
      justify-content: space-between;

      .tit {
        font-size: 24px;
        flex: 1;
        // @extend %ellipse;
      }

      .date {
        color: $grayLight;
      }
    }

    .content {
      margin-top: 20px;
      line-height: 20px;
    }
  }
}
</style>
